import { Component, Inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DwLookupInfo, DwMetaDataService, DwMetaDataServiceToken, formatDateTimeToLocal } from '@devwareapps/devware-cap';
import { DateTimeUtilService } from '../../util/date-time-util.service';


@Component({
  selector: 'app-date-time-display-control',
  template: `
    <div class="read-only" [title]="timezone?.TimeZoneDescription || ''">{{ translatedDateTime }} <span [hidden]="!timezone">{{ timezone?.TimezoneShortName}}</span></div>

    <div class="dw-red" *ngIf="translatedDateTime != localDateTime" title="The event is in a different timezone than your current timezone">Different Timezone</div>
  `
})
export class DateTimeDisplayControlComponent implements OnInit, OnChanges {
  @Input() dateTime: string;
  @Input() timezoneId: number;

  dateTimeValue: any;
  timezoneLookups: DwLookupInfo[];
  timezone: DwLookupInfo;
  timezoneIANAIdentifier: any;
  translatedDateTime: string;
  localDateTime: string;
  localTimezone: DwLookupInfo;

  constructor(@Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
    private dateTimeUtilService: DateTimeUtilService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateValue();
  }

  ngOnInit() {
    this.updateValue();
  }

  private updateValue() {
    if (this.dateTimeValue == this.dateTime && !this.timezoneLookups) {
      return;
    }

    this.dateTimeValue = this.dateTime;

    const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    this.localDateTime = this.dateTimeUtilService.formatDateTimeToLocal(this.dateTimeValue);

    if (this.localDateTime?.indexOf('Invalid') > -1) {
      this.localDateTime = formatDateTimeToLocal(this.dateTimeValue, true, true);
    }

    this.translatedDateTime = this.localDateTime;
  }
}
